export const environment = {
  production: true,
  mediaLocation: 'media-content',
  origin: 'https://media.csesoftware.net'
};
